import { useState } from "react";
import { useNavigate } from "react-router-dom";

function ReservationCheck() {
  const [reservationNumber, setReservationNumber] = useState("");
  const [contact, setContact] = useState("");
  const [loading, setLoading] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [errors, setErrors] = useState({}); // <-- NEW

  const navigate = useNavigate();

  // Validation function
  const validateInputs = (reservation, contact) => {
    const newErrors = {};

    if (!reservation) {
      newErrors.reservation = "Reservation number is required";
    }

    
    if (!contact) {
      newErrors.contact = "Contact or email is required";
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const phoneRegex = /^[0-9]{7,15}$/; // 7 to 15 digits

      if (!emailRegex.test(contact) && !phoneRegex.test(contact)) {
        newErrors.contact = "Enter a valid email or phone number";
      }
    }

    return newErrors;
  };

  // function main
  const handleSearch = async (e) => {
    e.preventDefault();

    const trimmedReservation = reservationNumber.trim();
    const trimmedContact = contact.trim();

    // Validate before API call
    const validationErrors = validateInputs(trimmedReservation, trimmedContact);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setErrors({}); // clear previous errors

    const payload = {
      reservation: trimmedReservation,
      "contact/email": trimmedContact,
    };

    setLoading(true);
    setPopupMessage("");

    try {
      const response = await fetch(
        "https://backend.aombrerental.com/api/fetch_reservation",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();

      if (response.ok && data && Object.keys(data).length > 0) {
        navigate("/reservation-details", { state: { reservationData: data } });
      } else {
        setPopupMessage(data.message || "Reservation not found");
      }
    } catch (error) {
      console.error("Network error:", error);
      setPopupMessage("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center mt-32 mb-12 px-4">
      <div className="max-w-4xl w-full bg-white rounded-xl shadow-lg p-10">
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center text-[#353535] mb-6">
          Find Your <span className="text-[#ca8032]">Reservation</span>
        </h1>

        <form onSubmit={handleSearch} className="space-y-6">
          <div>
            <label className="block text-gray-700 font-medium mb-2">
              Reservation Number*
            </label>
            <input
              type="text"
              placeholder="Enter reservation number"
              value={reservationNumber}
              onChange={(e) => setReservationNumber(e.target.value)}
              className={`w-full px-5 py-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-[#ca8032] focus:border-[#ca8032] ${
                errors.reservation ? "border-red-500" : "border-gray-300"
              }`}
            />
            {errors.reservation && (
              <p className="text-red-500 text-sm mt-1">{errors.reservation}</p>
            )}
          </div>

          <div>
            <label className="block text-gray-700 font-medium mb-2">
              Contact/Email*
            </label>
            <input
              type="text"
              placeholder="Enter contact number or email"
              value={contact}
              onChange={(e) => setContact(e.target.value)}
              className={`w-full px-5 py-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-[#ca8032] focus:border-[#ca8032] ${
                errors.contact ? "border-red-500" : "border-gray-300"
              }`}
            />
            {errors.contact && (
              <p className="text-red-500 text-sm mt-1">{errors.contact}</p>
            )}
          </div>

          <button
            type="submit"
            className="w-full py-3 bg-[#ca8032] text-white font-semibold rounded-xl hover:bg-[#b77228] transition"
            disabled={loading}
          >
            {loading ? "Searching..." : "Search Reservation"}
          </button>
        </form>

        <p className="text-sm text-gray-500 mt-4 text-center">
          You cannot modify or cancel the booking
        </p>
      </div>

      {/* Popup */}
      {popupMessage && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
          <div className="bg-white p-6 rounded-xl shadow-lg text-center max-w-sm w-full">
            <p className="text-lg font-semibold text-gray-700">
              {popupMessage}
            </p>
            <button
              onClick={() => setPopupMessage("")}
              className="mt-4 px-5 py-2 bg-[#ca8032] text-white rounded-lg hover:bg-[#b77228] transition"
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default ReservationCheck;
